<template>
  <a-popup v-if="!$helper.isAmpPage($route.name)" v-bind="popupProps">
    <template v-slot:activator-content>
      <span class="article-info-date__text text-medium">
        {{ publishedDate }}
      </span>
    </template>

    <template v-slot:popup-content>
      <span class="article-info-date__popup-text text-medium">
        {{ popupDate }}
      </span>
    </template>
  </a-popup>

  <span v-else class="article-info-date__text text-medium">
    {{ publishedDate }}
  </span>
</template>

<script>
import { DateTime } from 'luxon'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import APopup from '@/components/_shared/APopup'
import { propValidator, PROP_TYPES } from '@fmpedia/validators'
import { LAYOUT } from 'shared/APopup/enums'

export default {
  name: 'AArticleInfoDate',
  mixins: [hydrationHelpers],
  components: { APopup },
  props: {
    publishedOn: propValidator([PROP_TYPES.STRING])
  },
  data() {
    return {
      layoutOrdering: {
        top: [LAYOUT.TOP_CENTER],
        bottom: [LAYOUT.BOTTOM_CENTER]
      },
      timestampPopupSettingsByBreakpoint: {
        [this.$breakpoint.aboveDesktopXl]: {
          modalWidth: 191
        }
      }
    }
  },
  computed: {
    popupProps() {
      return {
        layoutOrdering: this.layoutOrdering.top,
        popupSettingsByBreakpoint: this.timestampPopupSettingsByBreakpoint,
        showBeak: true
      }
    },
    publishedDate() {
      return this.isOlderThanOneDay()
        ? this.$helper.formatDate.toDateAndHours(this.publishedOn)
        : this.$helper.formatDate.toIntervalFromNow(this.publishedOn)
    },
    popupDate() {
      return this.$helper.formatDate.toDateAndHoursText(this.publishedOn)
    }
  },
  methods: {
    isOlderThanOneDay() {
      const givenDate = DateTime.fromISO(this.publishedOn)
      const oneDayAgo = DateTime.local().minus({ days: 1 })

      return givenDate < oneDayAgo
    }
  }
}
</script>

<style lang="scss">
.article-info-date__wrapper {
  position: relative;
  cursor: default;

  /deep/ .popup__wrapper {
    padding: 15px 10px;

    @include mobile {
      padding: 16px 8px;
    }
  }
}

.article-info-date__text {
  color: $c--gray-dark;
}

.article-info-date__popup-text {
  font-weight: 400;
}
</style>
